<template>
  <div class="c-activity-tile">    
    <div
      class="c-activity-tile__image-container"
      v-if="result.image != null"
      v-bind:style="{backgroundImage: 'url(' + result.image.url +')'}"
    ></div>
    <div class="c-activity-tile__content">
      <h2 v-if="result.title" class="c-activity-tile__title">{{result.title}}</h2>
      <span v-if="result.location && result.location.name" class="c-activity-tile__location">{{result.location.name}}</span>
      <p v-if="result.body" class="c-activity-tile__text">{{result.body}}</p>
      <a class="c-button c-button--brand"
      v-bind:href="result.url" 
      v-if="result.url"
      >View {{result.type}} Details</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "activity-results-card",
  props: {
    result: {
      type: Object,
      required: true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/components/geneco/community-search-results/activityResultsCard.vue